import Vue from 'vue'
import VueSimpleBreakpoints from 'vue-simple-breakpoints'

Vue.use(VueSimpleBreakpoints, { mobile: 320, tablet: 640, small_desktop: 1000, large_desktop: 1200 })